import { render, staticRenderFns } from "./formulario_campo_radio.vue?vue&type=template&id=c2bffef4&scoped=true&"
import script from "./formulario_campo_radio.vue?vue&type=script&lang=js&"
export * from "./formulario_campo_radio.vue?vue&type=script&lang=js&"
import style0 from "./formulario_campo_radio.vue?vue&type=style&index=0&id=c2bffef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bffef4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VRadio,VRadioGroup,VSwitch,VTextField})
